export default __webpack_public_path__ + "static/media/BusinessHoursIcon.d70f663e.svg";